// FALLBACK DATA — what /practices shows if Supabase can't be reached.
// The live schedule is edited in Connect (Admin → Website) and read from
// practice_sessions / practice_special_sessions / practice_locations.
// Keep this roughly in sync with the live Winter schedule.

export interface PracticeSession {
  day: string; // "Monday" … "Sunday"
  start24: string; // "17:30"
  end24: string; // "18:30"
  location: string; // acronym, e.g. "ORLC"
  gradeMin: number | null; // 0 = K
  gradeMax: number | null;
  universal: boolean; // shows for every grade filter
  paid: boolean;
  label: string;
  startsOn: string | null; // "2026-11-02"
}

export interface SpecialSession {
  blockTitle: string; // "Winter Tryouts"
  date: string; // "2026-10-26"
  start24: string;
  end24: string;
  group: string;
  location: string | null;
  visibleUntil: string; // "2026-10-29"
}

export interface PracticeNotice {
  title: string | null; // "Winter Tryouts"
  message: string;
  visibleUntil: string | null; // "2026-11-15"; null = until hidden in Connect
}

export interface PracticeLocation {
  acronym: string;
  name: string;
  address: string;
}

export interface PracticeData {
  season: string;
  sessions: PracticeSession[];
  specials: SpecialSession[];
  notices: PracticeNotice[];
  locations: PracticeLocation[];
}

const s = (
  day: string,
  start24: string,
  end24: string,
  gradeMin: number,
  gradeMax: number,
  label: string,
): PracticeSession => ({
  day,
  start24,
  end24,
  location: "ORLC",
  gradeMin,
  gradeMax,
  universal: false,
  paid: false,
  label,
  startsOn: "2026-11-02",
});

const t = (date: string, start24: string, end24: string, group: string): SpecialSession => ({
  blockTitle: "Winter Tryouts",
  date,
  start24,
  end24,
  group,
  location: "ORLC",
  visibleUntil: "2026-11-01",
});

export const fallbackPracticeData: PracticeData = {
  season: "Winter",
  sessions: [
    s("Monday", "17:30", "18:30", 2, 6, "2nd–6th Boys"),
    s("Monday", "18:30", "19:30", 6, 7, "6th Gold + 7th Boys (All)"),
    s("Monday", "19:30", "20:30", 8, 8, "8th Silver + 8th Boys"),
    s("Monday", "20:30", "21:30", 8, 12, "8th Gold + HS Boys"),
    s("Tuesday", "17:30", "18:30", 2, 6, "2nd–4th + 5th Gold/Silver + 6th Boys"),
    s("Tuesday", "18:30", "19:30", 6, 7, "6th Gold + 7th Boys (All)"),
    s("Tuesday", "20:30", "21:30", 8, 12, "8th & HS Boys"),
    s("Wednesday", "17:30", "18:30", 5, 6, "5th Gold/Silver + 6th Boys"),
    s("Wednesday", "18:30", "19:30", 6, 7, "6th Gold + 7th Boys (All)"),
    s("Wednesday", "20:30", "21:30", 8, 12, "8th & HS Boys"),
    s("Thursday", "17:30", "18:30", 2, 4, "2nd–4th Boys"),
    s("Thursday", "18:30", "19:30", 7, 7, "7th Boys"),
    s("Thursday", "19:30", "20:30", 5, 6, "5th & 6th Boys"),
    s("Thursday", "20:30", "21:30", 8, 12, "8th–HS Boys"),
  ],
  notices: [],
  specials: [
    t("2026-10-26", "18:30", "19:30", "5th & 6th Grade"),
    t("2026-10-26", "19:30", "20:30", "7th Grade"),
    t("2026-10-26", "20:30", "21:30", "8th Grade"),
    t("2026-10-27", "17:30", "18:30", "2nd–4th Grade"),
    t("2026-10-27", "18:30", "19:30", "5th Grade"),
    t("2026-10-27", "19:30", "20:30", "6th & 7th Grade"),
    t("2026-10-27", "20:30", "21:30", "8th Grade"),
    t("2026-10-28", "19:30", "20:30", "5th & 6th Grade"),
    t("2026-10-28", "20:30", "21:30", "7th & 8th Grade"),
    t("2026-10-29", "17:30", "18:30", "2nd–4th Grade"),
    t("2026-10-29", "18:30", "19:30", "5th Grade"),
    t("2026-10-29", "19:30", "20:30", "6th Grade"),
    t("2026-10-29", "20:30", "21:30", "7th & 8th Grade"),
  ],
  locations: [{ acronym: "ORLC", name: "Our Redeemer Lutheran Church", address: "7611 Park Ln, Dallas, TX 75225" }],
};
